module.exports = __webpack_public_path__ + "img/hotelFamily-2.d2222f66.jpg";